/**
 * this method should strip all invalid chars in file path
 * @param arg - file path
 */
export const getValidFilePath = (arg: string) =>
  arg.replace(/[/\\?%*:|"<>]/g, "");
